<div class="likes-count-wrapper" [ngClass]="wrapperCss" (click)="toggleLike()">
  <div class="like-icon-container" (click)="showTooltip($event)" (mouseleave)="hideTooltip()">
    @if (liked) {
    <img id="liked-icon" src="../assets/icons/thumbs%20up/thumbsup-16px-bold.svg" class="rating-icon">
    } @else {
    <img id="unliked-icon" src="../assets/icons/thumbs%20up/thumbsup-16px-gray-bold.svg"
      class="rating-icon">
    }
    <div class="tooltip" [class.show]="tooltipVisible" [style.left.px]="tooltipLeft" [style.top.px]="tooltipTop">
      {{ tooltipText }}
    </div>
  </div>
  @if (displayAsButton && liked) {
    <span class="rating-text">
      {{(likes | shortNumber)}}
    </span>
  } @else if (displayAsButton && !liked) {
    <span class="rating-text">Like</span>
  } @else {
    <span class="rating-text">
      {{(likes | shortNumber) + getLikeLabel()}}
    </span>
  }
</div>
